<template>
  <div :class="[{ white, padded, rounded }, 'card']">
    <slot></slot>
  </div>
</template>

<script>
export default {
  props: {
    padded: {
      type: Boolean,
      default: false
    },
    rounded: {
      type: Boolean,
      default: true
    },
    white: {
      type: Boolean,
      default: true
    }
  }
}
</script>

<style scoped rel="stylesheet/scss" lang="scss">
.card {
  &.padded {
    padding: 24px;
  }
  &.rounded {
    border-radius: 5px;
  }
  &.white {
    background-color: #fff;
  }
}
</style>
